import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { IOption } from '@shared/models/icommons.model';
import { UserSharedService } from '@shared/services/user-shared.service';
import { Observable } from 'rxjs';
import { UserInfoResolver } from './user-info.resolver';

/**
 * @deprecated
 */
@Injectable({
  providedIn: 'root',
})
export class UserMarketsResolver {
  constructor(
    private service: UserSharedService,
    private userResolver: UserInfoResolver
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<IOption[]> {
    const { id } = this.userResolver.resolve();
    return this.service.markets(id, undefined, route.data.all);
  }
}
